module.exports = __webpack_public_path__ + "static/media/trivia-round2.afc91b47.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/trivia-round2.png
// module id = 2679
// module chunks = 0